import React from 'react';
import type {
    SearchSuggestion,
    SearchSuggestionGroup,
} from '../view-models/search-suggestion';
import { SearchSuggestionItem } from './SearchSuggestionItem';
import { cn } from '../../../utils/cn';
import { useSearchTracking } from '@archipro-website/web/app/ui-rocco/hooks/use-search-tracking';
interface SearchSuggestionListProps {
    group: SearchSuggestionGroup;
    query: string;
    onOptionClick: (suggestion: SearchSuggestion | string) => void;
    variant?: 'default' | 'header';
    menuColor?: 'light' | 'dark';
}

const SUGGESTION_TYPE_TITLES = {
    keyword: 'Suggestions',
    categories: 'Categories',
} as const;

export const SearchSuggestionList: React.FC<SearchSuggestionListProps> = ({
    group,
    query,
    onOptionClick,
    variant = 'default',
    menuColor = 'dark',
}) => {
    const trackingConfig = useSearchTracking({ isSearchPage: true });
    return (
        <div>
            <span
                className={cn(
                    'font-medium md:mb-4',
                    variant === 'header' && menuColor === 'light'
                        ? 'text-white md:mb-0 md:text-dropdown'
                        : variant === 'header' && menuColor === 'dark'
                          ? 'text-gray-800 md:mb-0 md:text-dropdown'
                          : 'text-gray-800'
                )}
            >
                {SUGGESTION_TYPE_TITLES[group.type] || ''}
            </span>
            <div className="my-5 space-y-2.5 md:my-2.5 md:space-y-1.5">
                {group.options.map((option, optionIndex) => (
                    <SearchSuggestionItem
                        key={optionIndex}
                        label={
                            typeof option === 'string' ? option : option.title
                        }
                        type={
                            typeof option === 'string' ? undefined : option.type
                        }
                        query={query}
                        variant={variant}
                        menuColor={menuColor}
                        onClick={() => {
                            onOptionClick(option);
                            trackingConfig.onSuggestedCategoryClick(
                                typeof option === 'string'
                                    ? option
                                    : option.title
                            );
                        }}
                    />
                ))}
            </div>
        </div>
    );
};
